<div>
    <div>
        <div
            class="flex flex-column gap-2 border-1 surface-border flex align-items-center justify-content-between hover:surface-100 cursor-pointer border-round">
            <label [for]="rq.idRequisito">{{ rq.nombre }}</label>

            <p class="text-center" *ngIf="rq.idArchivoEstadoRq==1">
                <label
                    class="text-base text-color p-2 bg-gray-300 border-1 border-solid surface-border border-round  focus:border-primary">{{ rq.rqValue }}</label>
                <i [ngClass]="rq.idArchivoEstadoRq==1?'pi pi-verified text-2xl pl-1':'pi pi-info-circle text-2xl pl-1'"
                   [ngStyle]="{'color': rq.idArchivoEstadoRq==1?'green' : null}"
                   [pTooltip]="rq.idArchivoEstadoRq==1?'Ya cumplió este requisito':'Requisito pendiente'"
                   tooltipPosition="top"
                   class="mr-3"></i>
            </p>
            <p-inputGroup *ngIf="rq.idArchivoEstadoRq!=1">
                <input id="{{rq.idRequisito}}" name="inptrq" type="text"
                       [(ngModel)]="rq.reqValue"
                       ngDefaultControl
                       pInputText
                       class="ml-3 mr-3"
                       required="{{!rq.opcional&&rq.idArchivoEstadoRq!=1}}"
                       disabled="{{rq.idArchivoEstadoRq==1}}"
                       placeholder=""/>
                <ng-container
                    *ngTemplateOutlet="onSubmitTemplate; context: {$implicit: rq, clickEvent: onSubmitClicked.bind(this, rq)}"></ng-container>
            </p-inputGroup>
            <small>
                                           <span *ngIf="!rq.opcional&&rq.idArchivoEstadoRq!=1" class="text-sm"
                                                 [ngStyle]="{backgroundColor:'', color: 'var(--red-500)'}"> * Requerido *</span>
                <span *ngIf="rq.opcional&&rq.idArchivoEstadoRq!=1" class="text-sm"
                      [ngStyle]="{backgroundColor: '', color: 'var(--blue-500)'}">(Opcional)</span>
            </small>
        </div>
    </div>
</div>
